module.exports = __webpack_public_path__ + "static/media/artPortfolio.6f3f39da.svg";